import script from "./OrderStatusFormSelectInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderStatusFormSelectInput.vue?vue&type=script&lang=ts&setup=true"

import "./OrderStatusFormSelectInput.vue?vue&type=style&index=0&id=7df33596&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7df33596"]])

export default __exports__